import { render, staticRenderFns } from "./RecallDashboard.vue?vue&type=template&id=4fee09f6&"
import script from "./RecallDashboard.vue?vue&type=script&lang=js&"
export * from "./RecallDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports